import React from 'react';
import { FadeUp } from './FadeUp';
import { SignalFlow } from './illustrations/SignalFlow';
export function Solution() {
  const signals = [{
    label: 'Likes',
    desc: 'approval signal'
  }, {
    label: 'Comments',
    desc: 'community signal'
  }, {
    label: 'Shares',
    desc: 'value signal'
  }, {
    label: 'Saves',
    desc: 'relevance signal'
  }, {
    label: 'Views',
    desc: 'reach signal'
  }];
  const visualCards = [{
    icon: '❤️',
    title: 'Strategic Likes',
    desc: 'The first signal Instagram reads to decide whether to distribute your content further.'
  }, {
    icon: '💬',
    title: 'Real Comments',
    desc: 'Creates the perception of an active community. Builds trust the moment someone lands.'
  }, {
    icon: '🔁',
    title: 'Shares & Saves',
    desc: 'The highest-weight signals in the algorithm. They trigger organic reach spikes.'
  }, {
    icon: '▶️',
    title: 'Reel Views',
    desc: "Tells Instagram your content is worth pushing to people who don't follow you yet."
  }];
  return <section id="solucion" className="relative z-10 py-[72px] md:py-[100px]" data-id="element-226">
      <div className="max-w-[900px] mx-auto px-6" data-id="element-227">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-start" data-id="element-228">
          <FadeUp className="solucion-text" data-id="element-229">
            <span className="inline-block text-[11px] font-heading font-bold tracking-[0.25em] uppercase text-cyan mb-4" data-id="element-230">
              The solution
            </span>
            <h2 className="text-[clamp(26px,4vw,36px)] font-heading font-bold uppercase leading-[1.2] tracking-[0.05em] mb-6" data-id="element-231">
              We work on the factors that make an account{' '}
              <span className="text-cyan" data-id="element-232">grow and get noticed</span>
            </h2>
            <p className="text-white-dim text-base max-w-[560px] leading-[1.7] mt-3 mb-8" data-id="element-233">
              It's not about vanity numbers. It's about generating the right
              signals so Instagram amplifies your content and your audience
              perceives you as an authority.
            </p>

            <div className="bg-gradient-to-br from-cyan/5 to-cyan/0 border-l-[3px] border-cyan rounded-r-sm p-[22px_24px] mb-8" data-id="element-234">
              <p className="text-[15px] font-medium italic leading-[1.6] text-white" data-id="element-235">
                "Every action we generate on your account is designed so the
                algorithm reads it as genuine activity — and rewards you with
                more reach."
              </p>
            </div>

            <ul className="flex flex-col gap-3 list-none" data-id="element-236">
              {signals.map((sig, i) => <li key={i} className="flex items-center gap-3 text-[14px] text-white-dim" data-id="element-237">
                  <div className="w-1.5 h-1.5 bg-cyan rounded-sm shrink-0 shadow-[0_0_6px_#00e5ff]" data-id="element-238" />
                  <span data-id="element-239">
                    <strong className="text-white font-heading uppercase tracking-[0.05em] text-[12px]" data-id="element-240">
                      {sig.label}
                    </strong>{' '}
                    — {sig.desc}
                  </span>
                </li>)}
            </ul>
          </FadeUp>

          <div className="flex flex-col gap-4 relative" data-id="element-241">
            {/* Signal Flow Background */}
            <div className="absolute top-0 left-[-50px] w-[150px] h-full pointer-events-none -z-10" data-id="element-242">
              <SignalFlow data-id="element-243" />
            </div>

            {visualCards.map((card, i) => <FadeUp key={i} delay={i * 0.08} data-id="element-244">
                <div className="bg-bg-card border border-cyan/10 rounded-sm p-[22px_24px] flex items-center gap-[18px] transition-all duration-250 ease-in hover:border-cyan/40 card-glow-hover" data-id="element-245">
                  <span className="text-[28px] shrink-0" data-id="element-246">{card.icon}</span>
                  <div data-id="element-247">
                    <h4 className="text-[14px] font-heading font-semibold uppercase tracking-[0.05em] mb-1.5" data-id="element-248">
                      {card.title}
                    </h4>
                    <p className="text-[13px] text-white-dim leading-[1.5]" data-id="element-249">
                      {card.desc}
                    </p>
                  </div>
                </div>
              </FadeUp>)}
          </div>
        </div>
      </div>
    </section>;
}